import { render, staticRenderFns } from "./AssetsDevices.vue?vue&type=template&id=d65b3770&"
import script from "./AssetsDevices.vue?vue&type=script&lang=js&"
export * from "./AssetsDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports